<script lang="ts">
	export let count = 0
	export { className as class }
	let className = ''

	$: text = count > 0 ? count.toString() : ''
	$: badge_color = count > 0
</script>

<span class="badge {className}" class:badge_color {...$$restProps}>
	{text}
</span>

<style lang="postcss">
	.badge {
		display: inline-flex;
		border-radius: 0.25rem; /* 4px */
		padding: 2px 4px 2px 4px;
		font-weight: 500;
		font-size: 0.75rem; /* 12px */
		line-height: 1rem; /* 16px */
		position: absolute;
		top: -4px;
		right: -4px;
	}

	.badge_color {
		@apply bg-red-600 text-white;
	}
</style>
